define("window", [],function () {
  return window;
});
